/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useContext, useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import {
  Grid,
  GridColumn as Column,
  GridColumn,
} from "@progress/kendo-react-grid";
import Layout from "components/layout";
import {
  useAssignB2BBags,
  useGetB2BServiceDetails,
  useUpdateB2BBags,
} from "utils/apis/b2b.api";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Button,
  Card,
  CardContent,
  CardDescription,
  Combobox,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@repo/ui";
import { LookUpContext } from "utils/reducers/lookup";
import type { UseFormReturn } from "react-hook-form";
import { useForm, useFieldArray } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import type { BagType, CoinsDenom, Currency } from "utils/types/lookup.type";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { useGetAllBagTypes } from "utils/apis/lookups.api";
import { PlusCircle, TrashIcon } from "lucide-react";
import {
  BAG_COINS_DENOMINATIONS,
  BOX_COINS_DENOMINATIONS,
} from "utils/constant";

const formSchema = z
  .object({
    consignmentType: z
      .string()
      .min(1, { message: "Consignment Type is required." }),
    containerType: z.string().min(1, { message: "Bag Type is required." }),
    containerId: z.string().min(1, { message: "ContainerId is required." }),
    details: z.string(),
    currency: z.string().min(1, { message: "Currency is required." }),
    declaredValue: z
      .number()
      .min(0, { message: "Declared Value is required." }),
    exchangeRate: z
      .number()
      .min(0.001, { message: "Exchange Rate is required." }),
    count: z.number().min(1, { message: "Count is required." }),
    sealNo: z.string().optional(),
    remarks: z.string().optional(),
    packedCurrencies: z.array(
      z.object({
        currency: z.string(),
        declaredValue: z.number(),
        exchangeRate: z.number(),
      }),
    ),
    denominations: z.array(
      z.object({
        denomination: z.string(),
        shape: z.string(),
        count: z.number(),
      }),
    ),
  })
  .superRefine((val, ctx) => {
    if (!val.sealNo && val.consignmentType !== "Coins") {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["sealNo"],
        message: "Seal no. is required",
      });
      return true;
    }
  });

export default function ViewB2BOrder() {
  const [searchParams] = useSearchParams();

  const { data: orderDetail } = useGetB2BServiceDetails({
    requestId: searchParams.get("requestId"),
    jobNo: searchParams.get("jobNo"),
  });

  const {
    mutate: assignB2BBags,
    isPending: isAssignB2BPending,
    // isSuccess: isAssignB2BSuccess,
  } = useAssignB2BBags();

  const {
    mutate: updateB2BBags,
    isPending: isUpdateB2BPending,
    // isSuccess: isUpdateB2BSuccess,
  } = useUpdateB2BBags();

  const { currencies, coinContainers } = useContext(LookUpContext);
  const [consignments, setConsignments] = useState<any[]>([]);
  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      consignmentType: "",
      containerType: "",
      containerId: "",
      details: "",
      currency: "",
      declaredValue: 0,
      exchangeRate: 1,
      count: 1,
      sealNo: "",
      remarks: "",
      packedCurrencies: [],
      denominations: [],
    },
  });
  const { control } = form;
  const { fields, append, remove } = useFieldArray({
    control,
    name: "packedCurrencies",
  });
  const { data: allBagTypes } = useGetAllBagTypes("B2B");

  const consignmentType = form.watch("consignmentType");
  const containerType = form.watch("containerType");

  const handleChangeBagType = (val: string) => {
    const selectedBag = (allBagTypes as BagType[])?.find(
      (i) => i.description === val,
    );
    if (selectedBag) {
      form.setValue("consignmentType", selectedBag.consignmentType);
      form.setValue("containerId", String(selectedBag.code));
      if (selectedBag.consignmentType === "Coins") {
        form.setValue("currency", "AED");
      }
    }
  };

  const handleChangeCurrency = (val: string) => {
    const selectedCurr = (currencies as Currency[])?.find(
      (i) => i.shortName === val,
    );
    if (selectedCurr) {
      form.setValue("exchangeRate", selectedCurr?.exchangeRate || 1);
    }
  };

  function onSubmit(values: z.infer<typeof formSchema>) {
    values.currency =
      containerType === "Foreign Currency" ? "FC" : values.currency;

    if (values.consignmentType === "Coins") {
      const selectedCoin = (coinContainers as CoinsDenom[])?.find(
        (i) =>
          i.denomination === values.details &&
          i.containerType === containerType,
      );
      if (selectedCoin) {
        values.declaredValue = selectedCoin?.valuePerContainer * values.count;
      }
    }

    setConsignments((prev) => [
      ...prev,
      { ...values, deleteId: crypto.randomUUID() },
    ]);
    form.reset();
  }

  function DeleteCell(props: any) {
    const { dataIndex } = props;
    return (
      <td {...props}>
        <TrashIcon
          className="text-red-500 cursor-pointer"
          type="button"
          onClick={() => {
            remove(dataIndex);
          }}
        />
      </td>
    );
  }

  const handleDelete = (id: string) => {
    let filterContainerData = consignments?.slice();
    filterContainerData = filterContainerData?.filter(
      (item) => item?.deleteId !== id,
    );
    setConsignments(filterContainerData);
  };

  const handleSave = () => {
    if (orderDetail?.consignmentsAssigned) {
      updateB2BBags({
        requestId: orderDetail?.requestId,
        jobNo: orderDetail?.jobNo,
        consignments,
      });
    } else {
      assignB2BBags({
        requestId: orderDetail?.requestId,
        jobNo: orderDetail?.jobNo,
        consignments,
        consignmentsAssigned: orderDetail?.consignmentsAssigned,
      });
    }
  };

  useEffect(() => {
    if (orderDetail?.collectedConsignments?.containers?.length) {
      setConsignments(
        orderDetail?.collectedConsignments?.containers?.map((item: any) => ({
          ...item,
          deleteId: crypto.randomUUID(),
        })),
      );
    }
  }, [orderDetail?.collectedConsignments?.containers]);

  return (
    <Layout>
      <Breadcrumb className="mt-5 mx-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <Link to="/dashboard">Home</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <Link to="/b2b-services">B2B </Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>B2B Request Detail</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>

      <Card className="mt-3 mx-4">
        <CardContent>
          <CardDescription className="pt-6">
            <div className="flex justify-between">
              <h2 className="text-lg">Job #{orderDetail?.jobNo}</h2>{" "}
              <Button variant="secondary">
                <Link to="/b2b-services">Close</Link>
              </Button>
            </div>
            <div className="flex flex-wrap gap-4 mt-4">
              <OrderUtil label="Order Id" value={orderDetail?.orderId} />
              <OrderUtil label="Job Type" value={orderDetail?.jobType} />
              <OrderUtil label="Type" value={orderDetail?.serviceType} />
              <OrderUtil label="Status" value={orderDetail?.status} />
              <OrderUtil
                label="Customer"
                value={orderDetail?.billingCustomerName}
              />
              <OrderUtil
                label="Pickup Location"
                value={orderDetail?.sourceLocationName}
              />
              <OrderUtil
                label="Onward Location"
                value={orderDetail?.onwardLocationName}
              />
              <OrderUtil label="Pickup Time" value={orderDetail?.pickupTime} />
              <OrderUtil
                label="Delivery Time"
                value={orderDetail?.deliveryTime}
              />
            </div>
            <hr className="border my-5" />
            <Form {...form}>
              <form
                id="collection-form"
                onSubmit={form.handleSubmit(onSubmit)}
                className="gap-4 grid grid-cols-2 mt-3"
              >
                <FormCombobox
                  form={form}
                  data={allBagTypes?.map((item: BagType) => ({
                    label: item?.description,
                    value: item?.description,
                  }))}
                  name="containerType"
                  label="Bag Type"
                  placeholder="Select Bag Type"
                  onChange={handleChangeBagType}
                />
                {containerType !== "Foreign Currency" ? (
                  <FormCombobox
                    form={form}
                    data={currencies.map((item: Currency) => ({
                      label: item?.name,
                      value: item?.shortName,
                    }))}
                    name="currency"
                    label="Currency"
                    placeholder="Select Currency"
                    onChange={handleChangeCurrency}
                    disabled={consignmentType === "Coins"}
                  />
                ) : null}

                {consignmentType === "Coins" ? (
                  <>
                    <FormSelect
                      form={form}
                      data={
                        containerType === "Coins Box"
                          ? BOX_COINS_DENOMINATIONS
                          : BAG_COINS_DENOMINATIONS
                      }
                      name="details"
                      label="Coin Denomination"
                      placeholder="Select Denomination"
                    />
                    <FormField
                      control={form.control}
                      name="count"
                      render={({ field }) => (
                        <FormItem>
                          <FormLabel>Count</FormLabel>
                          <FormControl>
                            <NumericTextBox
                              step={0}
                              spinners={false}
                              min={1}
                              className="w-full h-10"
                              {...field}
                            />
                          </FormControl>
                          <FormMessage />
                        </FormItem>
                      )}
                    />
                  </>
                ) : (
                  <>
                    {containerType !== "Foreign Currency" ? (
                      <FormField
                        control={form.control}
                        name="declaredValue"
                        render={({ field }) => (
                          <FormItem>
                            <FormLabel>Declared Value</FormLabel>
                            <FormControl>
                              <NumericTextBox
                                step={0}
                                spinners={false}
                                min={0}
                                className="w-full h-10"
                                {...field}
                              />
                            </FormControl>
                            <FormMessage />
                          </FormItem>
                        )}
                      />
                    ) : null}
                    <FormField
                      control={form.control}
                      name="sealNo"
                      render={({ field }) => (
                        <FormItem>
                          <FormLabel>Seal No.</FormLabel>
                          <FormControl>
                            <Input
                              type="text"
                              placeholder="Seal no."
                              {...field}
                            />
                          </FormControl>
                          <FormMessage />
                        </FormItem>
                      )}
                    />
                  </>
                )}

                {containerType === "Foreign Currency" ? (
                  <div className="w-full col-span-2">
                    <div className="grid grid-cols-[1fr_1fr_max-content]  items-end gap-3 mb-3">
                      <FormCombobox
                        form={form}
                        data={currencies.map((item: Currency) => ({
                          label: item?.name,
                          value: item?.shortName,
                        }))}
                        name="currency"
                        label="Foreign Currency"
                        placeholder="Select Currency"
                        onChange={handleChangeCurrency}
                      />
                      <FormField
                        control={form.control}
                        name="declaredValue"
                        render={({ field }) => (
                          <FormItem>
                            <FormLabel>Declared Value</FormLabel>
                            <FormControl>
                              <NumericTextBox
                                step={0}
                                spinners={false}
                                min={0}
                                className="w-full h-10"
                                {...field}
                              />
                            </FormControl>
                            <FormMessage />
                          </FormItem>
                        )}
                      />
                      <Button
                        variant="secondary"
                        size="icon"
                        type="button"
                        onClick={() => {
                          append({
                            currency: form.getValues("currency"),
                            exchangeRate: form.getValues("exchangeRate"),
                            declaredValue: form.getValues("declaredValue"),
                          });
                        }}
                      >
                        <PlusCircle />
                      </Button>
                    </div>
                    <Grid data={fields} className="my-3">
                      <GridColumn field="currency" title="Currency" />
                      <GridColumn
                        field="declaredValue"
                        title="Value"
                        format="{0:N2}"
                      />
                      <GridColumn field="exchangeRate" title="Exchange Rate" />
                      <GridColumn
                        field="deleteId"
                        title="Remove"
                        cell={DeleteCell}
                      />
                    </Grid>
                  </div>
                ) : null}
                <div className="flex gap-2 justify-end col-span-2">
                  <Button variant="secondary" type="submit">
                    Add Bag
                  </Button>
                </div>
              </form>
            </Form>
            <AssignmentDetails
              title="Consignment Details"
              data={consignments || []}
              handleDelete={handleDelete}
            />
            <Button
              variant="secondary"
              className="flex ml-auto mt-3"
              onClick={handleSave}
              isLoading={isAssignB2BPending || isUpdateB2BPending}
              disabled={isAssignB2BPending || isUpdateB2BPending}
            >
              Save
            </Button>
          </CardDescription>
        </CardContent>
      </Card>
    </Layout>
  );
}

function OrderUtil({ label, value }: any) {
  return (
    <div className="w-full max-w-[calc(25%_-_25px)]">
      <strong>{label}</strong>
      <span className="block">{value}</span>
    </div>
  );
}

function AssignmentDetails({ data, title, handleDelete }: any) {
  function ActionCell(props: any) {
    const { dataItem } = props;
    return (
      <td {...props}>
        <TrashIcon
          className="text-red-500 cursor-pointer"
          onClick={() => {
            handleDelete(dataItem?.deleteId);
          }}
        />
      </td>
    );
  }
  return (
    <>
      <h4 className="mb-3 mt-5 text-lg font-semibold">{title}</h4>
      <Grid data={data} size="small">
        <Column field="consignmentType" title="Consignment" width="160px" />
        <Column field="containerType" title="Container" />
        <Column field="containerId" title="Container ID" />
        <Column field="details" title="Details" />
        <Column field="currency" title="Currency" width="85px" />
        <Column field="declaredValue" format="{0:N2}" title="Value" />
        <Column field="count" title="Count" width="80px" />
        <Column field="sealNo" title="Seal No." />
        <GridColumn
          field="deleteId"
          title="Action"
          cell={ActionCell}
          width="100px"
          className="text-center"
        />
      </Grid>
    </>
  );
}

function FormSelect({
  form,
  name,
  label,
  placeholder,
  data,
  onChange,
  disabled,
}: {
  form: UseFormReturn<z.infer<typeof formSchema>>;
  name: keyof z.infer<typeof formSchema>;
  label: string;
  placeholder?: string;
  data?: { label: string; value: string | number }[];
  onChange?: (e: string) => void;
  disabled?: boolean;
}) {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{label}</FormLabel>
          <Select
            onValueChange={(e) => {
              field.onChange(e);
              onChange?.(e);
            }}
            value={field.value as string}
            disabled={disabled}
          >
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder={placeholder} />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {data?.map((item) => (
                <SelectItem key={item.value} value={String(item.value)}>
                  {item.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}

function FormCombobox({
  form,
  name,
  label,
  placeholder,
  data,
  onChange,
  disabled,
  ...props
}: {
  form: UseFormReturn<z.infer<typeof formSchema>>;
  name: keyof z.infer<typeof formSchema>;
  label: string;
  placeholder: string;
  data?: { label: string; value: any }[];
  disabled?: boolean;
  onChange?: (e: any) => void;
}) {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{label}</FormLabel>
          <Combobox
            value={field.value as any}
            setValue={(e: string) => {
              field.onChange(e);
              onChange?.(e);
            }}
            data={data}
            placeholder={placeholder}
            disabled={disabled}
            {...props}
          />
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
